import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

// Paleta Clara (Adaptada al diseño de CallsV2)
const lightTheme = {
  paperBg: "#ffffff",         // Fondo blanco limpio
  textColor: "#1f2937",       // Texto gris oscuro (casi negro)
  dividerColor: "#e5e7eb",    // Gris muy claro para divisores/bordes
  backdropBg: "rgba(0, 0, 0, 0.4)", // Fondo oscuro estándar para el backdrop
  titleColor: "#1f2937",      // Título en gris oscuro
  closeIconColor: "#9ca3af",  // Icono de cerrar en gris tenue
};

export const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    // Usamos el fondo blanco claro para que coincida con CallsV2.js
    backgroundColor: lightTheme.paperBg,
    color: lightTheme.textColor,
    padding: theme.spacing(1), // Reducimos un poco el padding general
    borderRadius: 12,
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)", // Sombra suave
    maxWidth: "900px !important", // Fixed explicit constraint
    width: "100%", // Fit gracefully in smaller screens
    margin: theme.spacing(2),
    overflow: "hidden",
    border: `1px solid ${lightTheme.dividerColor}`, // Borde sutil
    maxHeight: "65vh !important" // Strict vertical height to avoid huge modals
  },
  "& .MuiBackdrop-root": {
    backgroundColor: lightTheme.backdropBg, // Backdrop estándar
  },
}));

export const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: theme.typography.h6.fontSize,
  fontWeight: 700, // Títulos más audaces
  textAlign: "left", // Alineación a la izquierda para un look moderno
  padding: theme.spacing(2, 3),
  position: "relative",
  borderBottom: `1px solid ${lightTheme.dividerColor}`,
  color: lightTheme.titleColor,
}));

export const DialogCloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: lightTheme.closeIconColor,
  "&:hover": {
    color: lightTheme.textColor, // Se oscurece al pasar el ratón
    backgroundColor: 'transparent',
  },
}));

export const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  padding: theme.spacing(3),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  color: lightTheme.textColor,
}));

export const CustomDialogActions = styled(DialogActions)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  padding: theme.spacing(1, 3, 2),
  borderTop: `1px solid ${lightTheme.dividerColor}`,
  // No necesitamos color de fondo extra aquí, ya es el mismo que el del papel.
}));

// Exportamos los componentes para que se puedan usar
export {
  DialogTitle as CustomDialogTitleComponent,
  DialogContent as CustomDialogContentComponent,
  DialogActions as CustomDialogActionsComponent
};